<div class="app-update ac-flex ac-algn-ctr ac-gap-lg">
  <div class="ac-flex-itm-80">
    <div class="app-update-description">
      There is an update available. The page will automatically refresh in
    </div>
    <ac-countdown-timer
      format="MS"
      [endTime]="endTime()"
      (stopped)="update()"
    />.
  </div>
  <button
    mat-flat-button
    type="button"
    class="ac-flex-itm-20"
    (click)="update()"
  >
    Update
  </button>
</div>
